const state = {
  pagy: {},
  reviews: [],
  totalPageCount: 0,
  isLoadingProductReviewThumbnails: true
};

const mutations = {
  SET_REVIEWS(state, data) {
    state.reviews = data.reviews;
    state.pagy = data.pagy;
    state.totalPageCount = data.total_page_count;
  },
  APPEND_REVIEWS(state, data) {
    state.reviews = [...state.reviews, ...data.reviews];
    const prev = state.pagy.prev;
    state.pagy = data.pagy;
    state.pagy.prev = prev;
  },
  PREPEND_REVIEWS(state, data) {
    state.reviews = [...data.reviews, ...state.reviews];
    const next = state.pagy.next;
    state.pagy = data.pagy;
    state.pagy.next = next;
  },
  SET_IS_LOADING_PRODUCT_REVIEW_THUMBNAILS(
    state,
    isLoadingProductReviewThumbnails
  ) {
    state.isLoadingProductReviewThumbnails = isLoadingProductReviewThumbnails;
  }
};

const actions = {
  fetchProductReviewThumbnails(
    { commit, rootState },
    {
      review_id = null,
      product_code = null,
      page = null,
      fields = null,
      append = false,
      prepend = false
    }
  ) {
    commit('SET_IS_LOADING_PRODUCT_REVIEW_THUMBNAILS', true);
    return rootState.api
      .fetchProductReviewThumbnails({ review_id, product_code, page, fields })
      .then(({ data }) => {
        commit(
          append
            ? 'APPEND_REVIEWS'
            : prepend
            ? 'PREPEND_REVIEWS'
            : 'SET_REVIEWS',
          data
        );
      })
      .finally(() => {
        commit('SET_IS_LOADING_PRODUCT_REVIEW_THUMBNAILS', false);
      });
  }
};

export default { namespaced: true, state, mutations, actions };
